<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import CkeditorWidget from "@/components/widgets/editor.vue";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Form Soal Esai",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CkeditorWidget,
  },
  data() {
    return {
      title: "Soal Esai",
      items: [
        {
          text: "Master Soal",
          href: "/",
        },
        {
          text: "Form Soal Esai",
          active: true,
        },
      ],
      idKompetensi: this.$route.params.id,
      formData: {
        soal_text: "",
        soal_image: null,
        pertanyaan: "",
        jumlah_jawaban: "", // required jika Pilihan Ganda
        tipe: "Text", // Pilihan Ganda | Text
        keywords: [
          {
            keyword: "",
            skor: 0,
          },
        ], // required jika tipe Text
        kategori_idkategori: "",
        jawaban: [],
        timer: 0,
        nomor_urut: 1,
        previewUrl: "",
      },
      kompetensi: {},
      listKategori: [],
      idSoal: this.$route.params.idsoal,
      showModalPreview: false,
    };
  },
  async mounted() {
    this.getData();
    this.getKategori();
    this.getKompetensi();
  },
  methods: {
    async getData() {
      if (this.idSoal) {
        const data = await axios
          .get(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi/" +
              this.idKompetensi +
              "/soal/" +
              this.idSoal,
            {
              headers: {
                Authorization: "Bearer " + localStorage.access_token,
                Accept: "Application/json",
              },
            }
          )
          .then((response) => response.data.data)
          .catch((err) => {
            console.log(err);
            return false;
          });
        if (data) {
          this.formData = data;
        }
      }
    },
    async searchKategori(search, loading) {
      if (search.length) {
        loading(true);
        this.getKategori(search, loading);
      }
    },
    async getKategori(search = "", loading) {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kategori/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.listKategori = data;
      }
      if (loading) loading(false);
    },
    async getKompetensi() {
      // let idKompetensi = this.$router.params;
      console.log(this.$route.params.id);
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    save() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "master/kompetensi/" +
        this.idKompetensi +
        "/soal";
      let method = "post";
      if (this.idSoal != undefined) {
        url += "/" + this.idSoal;
        method = "put";
      }

      Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: "Apakah Anda Yakin?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            url: url,
            method: method,
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
            data: this.formData,
          })
            .then((response) => response.data.data)
            .catch((error) => {
              console.log(error);
              let err = error.response.data.data;
              Swal.fire({
                icon: "warning",
                title: "Terjadi Kesalahan",
                text: err,
                timer: 3000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Create data berhasil",
              timer: 1000,
              timerProgressBar: true,
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.backToList();
          }
        }
      });
    },
    inputFilePhoto() {
      let self = this;
      if ($("#formImage")[0].files[0]) {
        if ($("#formImage")[0].files[0].size < 2242880) {
          $("#uploadLoading").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#formImage")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading").html("");
            $(".image").attr("src", urlres);
            $(".middle").attr("href", urlres);
            self.formData.soal_image = path_file;
            self.formData.previewUrl = urlres;
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    },
    addJawaban() {
      this.formData.keywords.push({
        keyword: "",
        skor: 0,
      });
    },
    async remJawaban(index) {
      if (this.formData.keywords.length == 1) {
        Swal.fire({
          icon: "warning",
          title: "Terjadi Kesalahan",
          text: "Pilihan jawaban tidak boleh kosong!",
        });
        return;
      }
      let proceed = true;
      if (Object.hasOwn(this.formData.keywords[index], "idkeyword")) {
        await Swal.fire({
          icon: "warning",
          title: "Konfirmasi!",
          text: "Apakah Anda Yakin?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `Iya`,
          denyButtonText: `Tidak`,
        }).then((result) => {
          if (result.isConfirmed) {
            proceed = true;
          } else {
            proceed = false;
          }
        });
      }
      if (proceed) {
        this.formData.keywords.splice(index, 1);
      }
    },
    backToList() {
      return this.$router.push({
        name: "soal-text",
        params: { id: this.idKompetensi },
      });
    },
    isChecked(row) {
      return row.skor == 1;
    },
    previewImage() {
      // window.open(this.formData.previewUrl, "_blank");
      this.showModalPreview = true;
    },
    deleteSoalImage() {
      Swal.fire({
        icon: "warning",
        title: "Perhatian!",
        text: "Apakah Anda yakin menghapus gambar ini ?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.formData.previewUrl = "";
          this.formData.soal_image = "";
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Form Soal Esai</div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{ kompetensi?.nama_kompetensi || "-" }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2"></div>
              </div>
              <div class="col-12">
                <hr />
                <div class="row mb-2">
                  <div
                    class="col-6 mb-2"
                    v-if="
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 3 ||
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 4
                    "
                  >
                    <div class="form group">
                      <label for="kategori_idkategori">Studi Kasus</label>
                      <!-- <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="formData.kategori_idkategori"
                      >
                        <option value="">-- Pilih Kategori --</option>
                        <option
                          v-for="row in listKategori"
                          :key="row.idkategori"
                          :value="row.idkategori"
                        >
                          {{ row.kategori }}
                        </option>
                      </select> -->
                      <v-select
                        id="form_kategori"
                        class="style-chooser"
                        :options="listKategori"
                        :reduce="(kategori) => kategori.idkategori"
                        label="kategori"
                        v-model="formData.kategori_idkategori"
                        placeholder="Pilih Kategori"
                        @search="searchKategori"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-6 mb-2">
                    <div class="form group">
                      <label for="kategori_idkategori">Timer</label>
                      <div class="input-group mb-3">
                        <input
                          type="number"
                          class="form-control"
                          placeholder="Timer"
                          v-model="formData.timer"
                        />
                        <span class="input-group-text" id="basic-addon2">
                          Detik
                        </span>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="kategori_idkategori">Nomor Urut</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Nomor urut"
                        v-model="formData.nomor_urut"
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="formImage" class="form-label">
                        Upload Gambar
                      </label>
                      <input
                        class="form-control"
                        type="file"
                        id="formImage"
                        v-on:change="inputFilePhoto()"
                      />
                      <div
                        class="respond-input-file float-left"
                        id="uploadLoading"
                      ></div>
                      <small class="float-right" style="color: red">
                        Max File 2 MB
                      </small>
                    </div>
                    <div class="container-image" v-if="formData.previewUrl">
                      <img :src="formData.previewUrl" class="image" />
                      <div
                        class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                      >
                        <button
                          class="btn btn-success btn-sm"
                          @click="previewImage"
                        >
                          <i class="fa fa-search"></i> Preview
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="deleteSoalImage"
                        >
                          <i class="fa fa-trash"></i> Hapus
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 mb-2 form-group">
                    <label for="soal_text">Soal</label>
                    <input
                      type="text"
                      id="soal_text"
                      class="form-control"
                      placeholder="Soal"
                      v-model="formData.soal_text"
                    />
                  </div> -->
                  <div class="col-12 mb-2 form-group">
                    <label for="pertanyaan">Pertanyaan</label>
                    <CkeditorWidget v-model="formData.pertanyaan" />
                  </div>
                  <!-- <div class="col-12 mb-2">
                    <label for="keywords">Keywords</label>
                    <textarea
                      id="keywords"
                      class="form-control form-control"
                      placeholder="Keywords"
                      v-model="formData.keywords"
                    ></textarea>
                  </div> -->
                  <div class="col-12 mb-2">
                    <table class="table table-striped table-condensed">
                      <thead class="text-center bg-dark text-white">
                        <tr>
                          <th width="10px"></th>
                          <th>Keyword</th>
                          <th width="100px">Poin</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(keyword, index) in formData.keywords"
                          :key="index"
                        >
                          <td>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="remJawaban(index)"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Keywords"
                              v-model="keyword.keyword"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control form-control-sm"
                              placeholder="Poin"
                              v-model="keyword.skor"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="d-grid gap-2">
                              <button
                                class="btn btn-success btn-sm"
                                type="button"
                                @click="addJawaban()"
                              >
                                <i class="fa fa-plus me-2"></i> Tambah
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 d-flex justify-content-end gap-2">
                    <button
                      class="btn btn-secondary btn-sm"
                      @click="backToList()"
                    >
                      <i class="fa fa-arrow-left me-1"></i>
                      Kembali
                    </button>
                    <button class="btn btn-primary btn-sm" @click="save()">
                      <i class="fa fa-save me-1"></i>
                      Simpan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>

  <b-modal
    v-model="showModalPreview"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="formData.previewUrl" class="image" />
    </div>
  </b-modal>
</template>
